import { render, staticRenderFns } from "./CustomerItems.vue?vue&type=template&id=bcc52890"
import script from "./CustomerItems.vue?vue&type=script&lang=js"
export * from "./CustomerItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports